export default {
  install(Vue) {
    Vue.directive('click-outside', {
      bind(el, binding, vnode) {
        setTimeout(() => {
          el.clickOutsideEvent = event => {
            // here I check that click was outside the el and his childrens
            if (
              !(
                el === event.target || el.contains(event.target)
              )
              && document.contains(event.target)
            ) {
              // and if it did, call method provided in attribute value
              vnode.context[binding.expression](event);
            }
          };
          document.body.addEventListener('click', el.clickOutsideEvent);
        });
      },
      unbind(el) {
        document.body.removeEventListener('click', el.clickOutsideEvent);
      },
    });

    Vue.directive('focus', {
      inserted(el, binding) {
        const { value } = binding;

        if (value !== false) {
          try {
            const element = $(el).find(':input');
            if (element) element.focus();
            else el.focus();
          } catch {
            el.focus();
          }
        }
      },
      update(el, binding) {
        const { value, oldValue } = binding || {};
        if (!oldValue && value === true) {
          Vue.nextTick(() => {
            try {
              const element = $(el).find(':input');
              if (element) element.focus();
              else el.focus();
            } catch {
              el.focus();
            }
          });
        }
      },
    });

    /**
      * @description Monitors an element and scrolls to the bottom if a new child is added
      * @Usage
      * smooth：smooth scroll or not (default: true)
      * always：Prevent scroll down when user has scrolled up (default: false)
    */
    Vue.directive('chat-scroll', {
      bind: (element, binding) => {
        let scrolled = false;

        element.addEventListener('scroll', () => {
          scrolled = element.scrollTop + element.clientHeight + 1 < element.scrollHeight;
        });

        new MutationObserver(event => {
          const config = binding.value || {};
          const pause = config.always === false && scrolled;

          const filteredEvents = event.filter(e => !e.target.className.includes('time'));
          if (pause || (filteredEvents[filteredEvents.length - 1]?.addedNodes?.length !== 1))
            return;

          scrollToBottom(element, config.smooth !== undefined ? config.smooth : true);
        }).observe(element, { childList: true, subtree: true });
      },
      inserted: scrollToBottom,
    });
  },
};

const scrollToBottom = (element, smooth) => {
  if (typeof element.scroll === 'function') {
    element.scroll({
      top: element.scrollHeight,
      behavior: smooth ? 'smooth' : 'instant',
    });
  } else {
    // eslint-disable-next-line no-param-reassign
    element.scrollTop = element.scrollHeight;
  }
};
